import React from 'react';
import { BodyText, Column, Row, Box } from '@chargify/custom-ui-components';
import { FontWeightType } from '@chargify/custom-ui-components';

import { TextAlign } from './DetailRow.styles';

export type Props = {
  label: {
    color?: string;
    value: string;
  };
  value: {
    color?: string;
    value: string;
    fontWeight?: FontWeightType;
    subValue?: {
      value: string;
      color?: string;
      fontWeight?: FontWeightType;
      fontSize?: number;
    };
  };
};

const DetailRow = ({ label, value }: Props) => (
  <Box marginBottom={3}>
    <Row>
      <Column span={[12, 8]}>
        <div data-testid="detail-label">
          <BodyText
            variant="body2"
            color={label.color || 'gray.dark'}
            fontWeight={2}
          >
            {label.value}
          </BodyText>
        </div>
      </Column>
      <Column span={[12, 8]}>
        <TextAlign data-testid="detail-value" textAlign={['right', 'left']}>
          <BodyText
            variant="body2"
            color={value.color || 'gray.dark'}
            fontWeight={value.fontWeight}
          >
            {value.value}{' '}
            {value.subValue && (
              <BodyText
                as={'span'}
                color={value.subValue.color || 'gray.dark'}
                fontWeight={value.subValue.fontWeight}
                variant={'body2'}
              >
                {value.subValue.value}
              </BodyText>
            )}
          </BodyText>
        </TextAlign>
      </Column>
    </Row>
  </Box>
);

export default DetailRow;
